import { LazyLoader, Modal } from '@bp/ui-components';
import { FragmentType } from 'client/gql';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CourseEditorsForm, CourseEditorsFormFragment } from '../forms/CourseEditorsForm';

type CourseEditorsModalProps = {
  isOpen: boolean;
  courseUuid: string;
  schoolYearUuid: string;
  onClose: () => void;
  query: FragmentType<typeof CourseEditorsFormFragment> | undefined;
};

export const CourseEditorsModal = ({ isOpen, courseUuid, schoolYearUuid, onClose, query }: CourseEditorsModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal loading={loading} isOpen={isOpen} onRequestClose={onClose} title={t('courses.editEditors')}>
      <Suspense fallback={<LazyLoader embedded forceHeight='58vh' />}>
        <CourseEditorsForm
          query={query}
          courseUuid={courseUuid}
          schoolYearUuid={schoolYearUuid}
          onLoad={setLoading}
          onClose={onClose}
        />
      </Suspense>
    </Modal>
  );
};
